import React, {FC, useCallback, useEffect, useMemo, useState} from 'react';
import {FilterCollapse} from 'plugins/modules/filter/components/FilterCollapse';
import {Radio} from 'plugins/modules/filter/components/Radio';
import {useRouter} from 'next/router';
import {IGetSearchFiltersProps, useGetSearchFiltersQuery} from 'modules/search-page-new/services';
import {useGetFiltersQueryData} from 'plugins/modules/filter/hooks/useGetFiltersQueryData';
import {FILTERS_CATEGORY_PLACEHOLDER} from 'plugins/modules/filter/components/Filters/constants';

export const SectionsFilter: FC = () => {
    const router = useRouter();

    const queryData = useGetFiltersQueryData({
        q: (router.query.q as string) ?? '',
    });

    const {data, isLoading} = useGetSearchFiltersQuery({
        ...(queryData as IGetSearchFiltersProps),
        section: router.query.section as string | undefined,
    });

    const {options = [], activeSectionCode} = useMemo(() => {
        const sectionsMap = data?.sections ?? {};
        const variants = Object.values(sectionsMap).map((section) => ({
            code: section.code,
            title: section.title,
            count: section.count,
            active: section.active,
        }));

        const allOption = {
            code: '',
            title: 'Все товары',
            count: variants.reduce((acc, v) => acc + (v.count || 0), 0),
        };

        const activeSection = variants?.find((variant) => variant.active);

        return {
            options: isLoading ? FILTERS_CATEGORY_PLACEHOLDER.items[0].variants : [allOption, ...variants],
            activeSectionCode: isLoading ? null : (activeSection?.code ?? ''),
        };
    }, [data?.sections, isLoading]);

    const [optimisticSectionCode, setOptimisticSectionCode] = useState<string | null>(null);

    useEffect(() => {
        if (null !== optimisticSectionCode && optimisticSectionCode === activeSectionCode) {
            setOptimisticSectionCode(null);
        }
    }, [activeSectionCode, optimisticSectionCode]);

    const selectedSectionCode = optimisticSectionCode ?? activeSectionCode;

    const onChange = useCallback(
        async (code: string) => {
            setOptimisticSectionCode(code);
            const nextQuery = {...router.query};
            nextQuery.section = code;

            await router.push({pathname: router.pathname, query: nextQuery}, undefined, {scroll: false, shallow: true});
        },
        [router],
    );

    if (!options.length) {
        return null;
    }

    return (
        <FilterCollapse hint={''} isDefaultOpen={true} title={'Категория'}>
            {options
                .filter((option) => 0 !== (option.count || 0))
                .map((option) => {
                    return (
                        <Radio
                            key={option.code ?? 'ALL'}
                            name={'section'}
                            title={option.title}
                            count={option.count}
                            isChecked={option.code === selectedSectionCode}
                            onChange={() => onChange(option.code)}
                        />
                    );
                })}
        </FilterCollapse>
    );
};
